import React, { useEffect, useState } from "react";
import { useSelector } from "../hooks/useTypedSelector";
import Navigation from "../layouts/Navigation";
import { Redirect, Route, useLocation } from "react-router-dom";
import qs from "qs";
import CONSTANTS from "../constants/constant.enum";
// import axios from "axios";
// import qs from "qs";
// import { useLoginInfo } from "../hooks/useLoginInfo";

const PrivateRoute = ({
  component: Component,
  hasNavigation = true,
  ...rest
}: {
  [key: string]: any;
}) => {
  const { search } = useLocation();
  const [isLogin, setIsLogin] = useState(null) as any;
  const [pathAfterLogout, setPathAfterLogout] = useState({
    pathname: "/",
    search,
  }) as any;

  const setLoginToFalse = () => {
    const queryStringParsed = qs.parse(search.slice(1));
    if (queryStringParsed[CONSTANTS.userHealthQrCodeParam]) {
      setPathAfterLogout({
        pathname: "/",
        search: qs.stringify({
          [CONSTANTS.userHealthQrCodeParam]: queryStringParsed.userHealthQrCode,
        }),
      });
      setIsLogin(false);
      return false;
    }
    setIsLogin(false);
    return false;
  };

  useEffect(() => {
    (() => {
      let userLoginInfo = localStorage.getItem("userLoginInfo") as any;

      if (userLoginInfo === null) {
        setLoginToFalse();
        return false;
      }

      try {
        // let hasAccessToken = JSON.parse(userLoginInfo) as any;
        setIsLogin(true);
        return false;
      } catch (e) {
        setLoginToFalse();
        return false;
      }
    })();

    // eslint-disable-next-line
  }, [isLogin]);

  // console.log("private routes is login? ", isLogin);
  const showNavigationData = useSelector((state) => state.showNavigation);

  return (
    <div className="user">
      {showNavigationData && hasNavigation ? <Navigation /> : null}
      {isLogin !== null ? (
        <Route
          {...rest}
          render={(props) =>
            isLogin ? (
              <Component {...props} />
            ) : (
              <Redirect to={pathAfterLogout} />
            )
          }
        />
      ) : (
        ""
      )}
    </div>
  );
};

export default PrivateRoute;
